<template>
  <validation-observer ref="costResultRowRef" novalidate tag="form">
    <custom-callout
      class-main="mt-3 rounded"
      :has-toggle="false"
      :opened="data.isOpen"
      @click:open="$emit('on-open-close')"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Servicio:</div>
          <div class="color-black font-16">
            {{ data.serviceTypeCdName | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Disciplina:</div>
          <div class="color-black font-16">
            {{ data.disciplineTypeName | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">SubDisciplina:</div>
          <div class="color-black font-16">
            {{ data.subDisciplineTypeName | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Modalidad:</div>
          <div class="color-black font-16">
            {{ data.serviceModalityTypeCdName | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Duración:</div>
          <div class="color-black font-16">
            {{ data.therapyDurationName | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Lugar:</div>
          <div class="color-black font-16">
            {{ data.locationTypeCdName | empty }}
          </div>
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14">Costo Máximo:</div>
          <validation-provider
            v-if="data.isEditMode"
            v-slot="{ errors }"
            rules="required|differentFromZero"
          >
            <custom-input
              ref="costMaxInputRef"
              v-model="data.editCost"
              custom-error-msg="El costo máximo es requerido."
              :error="errors[0]"
              type="number"
            />
          </validation-provider>
          <div v-else class="color-black font-16">
            {{ data.rpMaxServiceCost | price }}
          </div>
        </div>
        <div
          class="
            col col-sm col-12
            d-flex
            align-items-center
            justify-content-end
          "
        >
          <action-button
            v-if="data.isEditMode"
            class="btn-action-size"
            i="fas fa-save pl-0"
            variant="outline-success pl-2 pl-1"
            @click="onSaveHandler"
          />
          <action-button
            v-else
            class="btn-action-size"
            i="fas fa-edit pl-1"
            variant="outline-success pl-1"
            @click="$emit('on-edit')"
          />
          <action-button
            v-if="data.isEditMode"
            class="btn-action-size"
            i="fas fa-ban pl-1"
            variant="outline-danger m-2 pl-1"
            @click="$emit('on-cancel')"
          />
          <action-button
            v-else
            class="btn-action-size"
            i="fas fa-times-circle pl-1"
            variant="outline-danger m-2 pl-1"
            @click="$emit('on-delete')"
          />
        </div>
      </div>
    </custom-callout>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    ActionButton,
    CustomInput,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    async onSaveHandler() {
      const isValid = await this.$refs.costResultRowRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      if (this.data.editCost !== this.data.rpMaxServiceCost)
        this.$emit('on-save', { ...this.data });
      else this.$emit('on-cancel');
    },
  },
};
</script>

<style scoped lang="scss">
.btn-action-size {
  width: 35px;
  height: 35px;
}
</style>
